import { snapshotsResponseSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const snapshots = {
	forAthlete: (athleteId: string, list?: string) => {
		const query = list ? `?list=${encodeURIComponent(list)}` : "";
		return fetchApi(`/athletes/${athleteId}/snapshots${query}`, snapshotsResponseSchema);
	},
};
